import React, { FC } from 'react';
import { Button, HeaderText, Modal } from '@/components/ui';
import { BUTTON_STYLES } from '@/components/ui/Buttons/utils';
import Image from 'next/image';
import { HeaderSize } from '@/components/ui/HeaderText';
import { DIVIDER_IMAGES } from '../SubscriberShop/utils';

interface InventoryStatusModalProps {
  isOpen: boolean;
  handleClose: () => void;
  ctaText: string;
  title: string;
  description: string;
}

const InventoryStatusModal: FC<InventoryStatusModalProps> = ({
  isOpen,
  handleClose,
  ctaText,
  title,
  description,
}) => {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="container lg:w-[936px] lg:pt-6">
        <div className="mx-auto max-w-[700px] text-center">
          <HeaderText text={title} size={HeaderSize.H3} classes="mb-6" />
          <Image
            src={DIVIDER_IMAGES[2]}
            width={121}
            height={13}
            alt="divider"
            className="mx-auto mb-6 h-[5px] w-[71px] md:h-[13px] md:w-[121px]"
          />
          <p className="mb-6">{description}</p>
          <div className="mb-5 mt-5">
            <Button
              ctaText={ctaText || 'Keep Shopping'}
              onClick={handleClose}
              style={BUTTON_STYLES.primary}
              classes="mb-4 h-auto w-full md:w-[300px]"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InventoryStatusModal;
